import React from "react";

const GenderTable = ({ citizenData, caseData }) => {

  if (!citizenData || !caseData) return null;

  const genders = [
    { key: "male", label: "Male", color: "#6366F1" },
    { key: "female", label: "Female", color: "#EC4899" },
    { key: "other", label: "Other", color: "#8B5CF6" },
    { key: "not_available", label: "N/A", color: "#A1A1AA" }
  ];

  const totalCitizens = citizenData.total_count || 1;
  const totalCases = caseData.total_count || 1;

  return (
    <div className="bg-white rounded-xl shadow border border-gray-100">

      <div className="p-4 border-b">
        <h2 className="text-lg font-semibold">
          Gender Distribution
        </h2>
      </div>

      {/* Totals */}
      <div className="flex gap-6 p-4">

        <div className="bg-blue-50 p-4 rounded-lg border">
          <p className="text-sm text-blue-600">Unique Citizens</p>
          <p className="text-xl font-bold">
            {citizenData.total_count.toLocaleString()}
          </p>
        </div>

        <div className="bg-green-50 p-4 rounded-lg border">
          <p className="text-sm text-green-600">Total Cases</p>
          <p className="text-xl font-bold">
            {caseData.total_count.toLocaleString()}
          </p>
        </div>

      </div>

      {/* Table */}
      <div className="p-4">

        <table className="min-w-full border border-gray-200 rounded-lg">

          <thead className="bg-gray-50">
            <tr>
              <th className="p-3 text-left border-r">Gender</th>
              <th className="p-3 text-left border-r">Unique Citizens</th>
              <th className="p-3 text-left border-r">Total Cases</th>
              <th className="p-3 text-left border-r">Citizen %</th>
              <th className="p-3 text-left">Case %</th>
            </tr>
          </thead>

          <tbody>
            {genders.map(g => {

              const c = citizenData[`${g.key}_count`] || 0;
              const cs = caseData[`${g.key}_count`] || 0;

              return (
                <tr key={g.key} className="border-t hover:bg-gray-50">

                  <td className="p-3 border-r">
                    <div className="flex items-center">
                      <div
                        className="w-2.5 h-2.5 rounded-full mr-2"
                        style={{ backgroundColor: g.color }}
                      />
                      {g.label}
                    </div>
                  </td>

                  <td className="p-3 border-r">{c.toLocaleString()}</td>
                  <td className="p-3 border-r">{cs.toLocaleString()}</td>

                  <td className="p-3 border-r">
                    {((c / totalCitizens) * 100).toFixed(1)}%
                  </td>

                  <td className="p-3">
                    {((cs / totalCases) * 100).toFixed(1)}%
                  </td>

                </tr>
              );
            })}
          </tbody>

        </table>

      </div>

    </div>
  );
};

export default GenderTable;